/* global dcAnalytics customConfirmWithCallback loader setURLParam getParameterByName returnFalse */ // from general.js
/* global sendFriend */ // from send_friend.jsp js-page-specific-javascript-variables
/* global grecaptcha */

import { getToEmailsAsArray } from './initCloudspongeInParentFrame';
import { isEmailAddress } from '../utils/emailUtils.ts';

let existingContacts = null;

// eslint-disable-next-line no-unused-vars
window.csPageOptions = {
    textarea_id: 'to_emails',
    include: ['email'],
    beforeLaunch: function () {
        if ($.trim($('#to_emails').val()) !== '') {
            existingContacts = getToEmailsAsArray();
        } else {
            existingContacts = null;
        }
        return true;
    },
    // eslint-disable-next-line camelcase
    afterSubmitContacts: function (array_of_contacts) {
        if (existingContacts == null) existingContacts = [];
        for (let i = 0; i < array_of_contacts.length; i++) {
            const contact = array_of_contacts[i];
            existingContacts.push(contact.primaryEmail());
        }
        document.getElementById('to_emails').value = existingContacts.join(', ');
        window.checkNumEmailAddresses();
    },
};

(function () {
    function fitTextareaToContent(el) {
        el.style.height = '';
        el.style.height = (el.scrollHeight) + 'px';
    }

    addEventHandlers();
    function addEventHandlers() {
        $('.js-send-friend-form').on('submit', function () {
            return onFormSubmit();
        });
        $('.js-add-friends').on('click', function (e) {
            dcAnalytics.trackEventGA(['Tell A Friend', 'CloudSponge Contact Importer', 'Open']);
            e.preventDefault();
        });
        $('.js-to-emails')
            .on('input', function (e) {
                toEmailsFieldOnKeyUp(e);
            })
            .on('blur', toEmailsFieldOnBlur);
        $('.js-your-name').on('blur', function () {
            replaceYourName($(this).val());
        });
        $('.js-message').on('keyup', function () {
            fitTextareaToContent(this);
        });

        // don't allow carriage returns in subject
        $('.js-subject-field').on('keydown', function (event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                return false;
            }
        });

        // don't allow more than 2 returns
        $('.js-optional-greeting').on('keydown', function (event) {
            const newLines = $(this).val().split('\n').length;
            if (event.keyCode === 13 && newLines >= 3) {
                event.preventDefault();
                return false;
            }
        });

        $('.js-optional-greeting').on('keyup', function () {
            fitTextareaToContent(this);
        });
        $('.js-send-button').on('click', function () {
            dcAnalytics.trackOptX('tafsend_button');
            dcAnalytics.trackEventGA(['Tell A Friend', 'Email', 'Send']);
        });
    }

    const numEmailsAllowed = sendFriend.maxEmails;

    $(document).ready(function () {
        fitTextareaToContent($('.js-message')[0]);
        const errorMessage = sendFriend.errorMessage;
        if (errorMessage.length > 0) {
            dcAnalytics.trackEventGA(['Tell A Friend', 'Error', errorMessage]);
        }
        window.checkAllowSubmit();
    });

    function appendProjectLink(messageString) {
        const proposalHref = sendFriend.proposalHref;
        const itemTitle = sendFriend.itemTitle;

        if (messageString.indexOf(proposalHref) === -1) {
            return messageString.replace(itemTitle, itemTitle + ' (' + proposalHref + ')');
        }
        return messageString;
    }

    function toEmailsFieldOnKeyUp() {
        checkNumEmailAddresses();
    }

    function toEmailsFieldOnBlur() {
        checkNumEmailAddresses();
    }

    function checkNumEmailAddresses() {
        const emailArray = getToEmailsAsArray();
        let returnVal = true;

        if (emailArray != null && emailArray.length > numEmailsAllowed) {
            $('#to_emails').prop('disabled', true);
            const message = 'You can send email to a maximum of ' + numEmailsAllowed + ' addresses.';

            if ($('#customConfirm').length <= 0) {
                customConfirmWithCallback(message, {
                    hideCancelButton: true,
                    callback: function () {
                        $('#to_emails').prop('disabled', false);
                    },
                });
                $('body').one('triggeredHideHTMLLightbox.checkNumEmailAddresses', function () {
                    $('#to_emails').prop('disabled', false);
                });
            }
            $('#to_emails').val(emailArray.slice(0, numEmailsAllowed).join(','));
            returnVal = false;
        }
        return returnVal;
    }
    window.checkNumEmailAddresses = checkNumEmailAddresses;

    function replaceYourName(yourName) {
        if (yourName !== '') {
            document.tellAFriend.subject.value = document.tellAFriend.subject.value.replace('[Your Name]', yourName);
            $('#shareSubject').val(function (i, v) { return v.replace('[Your Name]', yourName); }).val();
        }
        document.tellAFriend.message.value = document.tellAFriend.message.value.replace('[Your Name]', yourName);
        $('#message').val(function (i, v) { return v.replace('[Your Name]', yourName); }).val();
    }

    function getParamValue(paramName) {
        const searchString = window.location.search;

        // +1 for the "="
        const paramIndex = searchString.indexOf(paramName) + paramName.length + 1;
        let paramValue = searchString.substring(paramIndex);

        if (paramValue.indexOf('&') > -1) {
            paramValue = paramValue.substring(0, paramValue.indexOf('&'));
        }

        return decodeURIComponent(paramValue);
    }

    function getSourceUrl() {
        const searchString = window.location.search;

        const previousPageParam = 'pageSource';
        const emailTemplateParam = 'utm_campaign';

        if (searchString.indexOf(previousPageParam) > -1) {
            return getParamValue(previousPageParam);
        } else if (searchString.indexOf(emailTemplateParam) > -1) {
            return 'email_' + getParamValue(emailTemplateParam);
        }
    }

    function onFormSubmit() {
        hideSendButton();
        const valid = validateTellAFriend();
        if (valid) {
            $('#source_url').val(getSourceUrl());
        } else {
            showSendButton();
        }
        return valid;
    }

    function hideSendButton() {
        $('#send_button').css('display', 'none');
        loader.showLoader('.js-send-button-wrapper', 'inline');
    }

    function showSendButton() {
        $('#send_button').css('display', 'inline');
        loader.removeLoader();
    }

    function validateTellAFriend() {
        if (document.tellAFriend.from_email.value === '' || !isEmailAddress(document.tellAFriend.from_email.value)) {
            alert('Please include your email address.');
            document.tellAFriend.from_email.focus();
            return false;
        }
        if (document.tellAFriend.from_name.value === '') {
            alert('Please include your name.');
            document.tellAFriend.from_name.focus();
            return false;
        }
        if (document.tellAFriend.from_name.value.length > 40) {
            alert('Please use 40 characters or less for your name.');
            document.tellAFriend.from_name.focus();
            return false;
        }
        const fromNameArray = (document.tellAFriend.from_name.value).split(/[\s]+/);
        if (fromNameArray.length > 4) {
            alert('Please use 4 components or less in your name.');
            document.tellAFriend.from_name.focus();
            return false;
        }
        if (document.tellAFriend.to_emails.value === '') {
            alert("Please include at least one email address. Your friends' email addresses will not be added to any mailing lists.");
            document.tellAFriend.to_emails.focus();
            return false;
        } else {
            const emailArray = getToEmailsAsArray();
            for (let e = 0; e < emailArray.length; e++) {
                if (!isEmailAddress(emailArray[e])) {
                    alert(emailArray[e] + ' is not a valid email address.');
                    document.tellAFriend.to_emails.focus();
                    return false;
                }
            }
        }
        // noinspection RedundantIfStatementJS
        if (checkNumEmailAddresses() === false) {
            return false;
        }
        return true;
    }

    // eslint-disable-next-line no-unused-vars
    function setUpMailTo(el) {
        let mailToString = 'mailto:';
        mailToString += $('#to_emails').val();
        mailToString += '?subject=' + encodeURIComponent($('#shareSubject').val());
        mailToString += '&body=' + encodeURIComponent(appendProjectLink($('#message').val())).replace(/%0A/g, '%0D%0A').replace(/<.*?>/g, '');
        el.href = mailToString;
        dcAnalytics.trackEventGA(['Tell A Friend', 'Contact Importer', 'Email Provider Not Shown']);
    }

    window.checkAllowSubmit = function () {
        if (
            $('#to_emails').val() === '' ||
                $('#from_name').val() === '' ||
                $('#from_email').val() === '' ||
                $('#shareSubject').val() === '' ||
                ($('#fixed-message').length > 0 && $('#fixed-message').html() === '') ||
                ($('#fixed-message').length === 0 && $('#message').val() === '') ||
                (typeof grecaptcha === 'undefined' || grecaptcha.getResponse().length === 0) // recaptcha required
        ) {
            $('#send_button').addClass('disabled');
        } else {
            $('#send_button').removeClass('disabled');
        }
    };

    $(document).ready(function () {
        $('#send-friend-form').keyup(function () { window.checkAllowSubmit(); });
    });
    $(window).on('load', function () {
        $('#to_emails').focus();
    });
})();

window.recaptchaSendFriendCallback = function () {
    window.checkAllowSubmit();
};
